import Vue from "vue";
import store from "../store";
import VueRouter from "vue-router";
import Dashboard from "@/modules/Dashboard/Dashboard.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Dashboard,
  },
  {
    path: "/directory",
    name: "directory",
    component: () => import("@/modules/DirectoryListings/DirectoryDash.vue"),
  },
  {
    path: "/directory-listings/:category?",
    name: "directory-listings",
    component: () =>
      import("@/modules/DirectoryListings/DirectoryListings.vue"),
    props: true,
  },
  {
    path: "/contact-us/:slug?",
    name: "contact-us",
    component: () => import("@/modules/TicketsAndEnquiries/TicketSystem.vue"),
    props: true,
  },
  {
    path: "/dashboard/:slug?",
    name: "dashboard",
    component: Dashboard,
    props: true,
  },
  {
    path: "/unsubscribe/:email?",
    name: "unsubscribe",
    component: () => import("@/modules/Sales/Unsubscribe.vue"),
    props: true,
  },
  {
    path: "/sales-dashboard",
    name: "sales-dashboard",
    component: () => import("@/modules/Sales/SalesDashboard.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/modules/Auth/Register.vue"),
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () => import("@/modules/Auth/ResetPassword.vue"),
  },
  {
    path: "/resetting-password",
    name: "resetting-password",
    component: () => import("@/modules/Auth/ResettingPassword.vue"),
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
